import { configureStore } from "@reduxjs/toolkit";
import { selectedTestsReducer } from "../../reducers";

export const store = configureStore({
  reducer: {
    selectedTests: selectedTestsReducer,
  },
});
